import { string, shape, object } from 'prop-types';

export default shape({
  label: string.isRequired,
  key: string.isRequired,
  validationConstraints: object,
  type: string.isRequired
});
